export enum DeliveryRateUnit {
  METRE = 'METRE',
  KILOMETER = 'KILOMETER',
  MILE = 'MILE',
}

export enum DeliveryRateType {
  STANDARD = 'STANDARD',
  SURGE = 'SURGE',
  WEATHER = 'WEATHER',
}

export interface DeliveryRateResponse {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
  maxDistance: number;
  minDistance: number;
  minPrice: number;
  maxPrice: number;
  rate: number;
  isActive: boolean;
  weatherMultiplier: number;
  isWeatherAffectingRate: boolean;
  surgeMultiplier: number;
  surgeThreshold: number;
  isSurgeAffectingRate: boolean;
  unit: DeliveryRateUnit;
  rateType: DeliveryRateType;
}
